<template>
  <div class="emergency-contacts">
    <div class="emergency-grid">
      <!-- Person 1 -->
      <div class="contact-field">
        <label>Person 1</label>
        <input class="form-control" type="text" v-model="form.APF_Emer1Name" :readonly="!canEdit" />
      </div>
      <div class="contact-field">
        <label>Relationship</label>
        <input class="form-control" type="text" v-model="form.APF_Emer1Relation" :readonly="!canEdit" />
      </div>
      <div class="contact-field">
        <label>Tel (M)</label>
        <input class="form-control" type="text" v-model="form.APF_Emer1Mobile" :readonly="!canEdit" />
      </div>
      <div class="contact-field">
        <label>Tel (H)</label>
        <input class="form-control" type="text" v-model="form.APF_Emer1Tel" :readonly="!canEdit" />
      </div>

      <!-- Person 2 -->
      <div class="contact-field">
        <label>Person 2</label>
        <input class="form-control" type="text" v-model="form.APF_Emer2Name" :readonly="!canEdit" />
      </div>
      <div class="contact-field">
        <label>Relationship</label>
        <input class="form-control" type="text" v-model="form.APF_Emer2Relation" :readonly="!canEdit" />
      </div>
      <div class="contact-field">
        <label>Tel (M)</label>
        <input class="form-control" type="text" v-model="form.APF_Emer2Mobile" :readonly="!canEdit" />
      </div>
      <div class="contact-field">
        <label>Tel (H)</label>
        <input class="form-control" type="text" v-model="form.APF_Emer2Tel" :readonly="!canEdit" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmergencyContactsSection',
  props: {
    form: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>
.emergency-contacts {
  width: 100%;
}

.emergency-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 1rem;
}

.contact-field {
  display: flex;
  flex-direction: column;
}

.contact-field label {
  font-weight: 500;
  margin-bottom: 5px;
  color: #333;
  font-size: 14px;
}

.form-control {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-control:readonly {
  background-color: #f8f9fa;
  opacity: 0.7;
}

@media (max-width: 768px) {
  .emergency-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}
</style>
